import {
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { DocumentEditorSidebarComponent } from './document-editor-sidebar/document-editor-sidebar.component';
import { TemplateObject } from './models/template-object';
import { TemplateObjectsService } from './services/template-objects.service';

@Component({
  selector: 'lib-template-process',
  templateUrl: './template-process.component.html',
  styleUrls: ['./template-process.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [],
})
export class TemplateProcessComponent implements OnInit, OnDestroy {
  saving: boolean;
  loading: boolean;
  isPreviewMode: boolean;
  @Input()
  showActions = true;
  @ViewChild('editorSidebar')
  editorSidebar: DocumentEditorSidebarComponent;

  hideSideMenu = true;
  @Input()
  template: TemplateObject;
  @Input()
  allowSaveAsPdf: boolean;
  @Input()
  allowSaveAsDocx: boolean;
  @Output()
  processClose: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  saveTemplate: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  saveAsPDF: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  saveMerged: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  fieldsDataObject: Map<string, any>;
  @Input()
  groupsDataObject: Map<string, any[]>;
  @Input()
  entityType = 'STD';
  @Input()
  entityId = '1026';
  @Input()
  backendProcessType: 'PROCESS_USING_PROVIDED_DATA' | 'PROCESS_USING_ENTITY';
  @Input()
  templateProcessorBaseUrl: string = this.documentTemplatesService.PROCESS_HOST_URL + '/api/documenteditor/';
  wopiUrl: string;
  accessToken: string;
  @ViewChild('form') form: ElementRef;
  @Input()
  allowSaveAsBase64: boolean;


  constructor(private documentTemplatesService: TemplateObjectsService, private cdref: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (!this.fieldsDataObject) {
      this.fieldsDataObject = new Map<string, any>();
    }
    if (!this.groupsDataObject) {
      this.groupsDataObject = new Map<string, any[]>();
    }
    this.documentTemplatesService.getCollaburaURL().subscribe(data => {
      const wopiClientUrl = data.url;
      const wopiSrc = `${this.documentTemplatesService.PROCESS_HOST_URL}/wopi/files/${this.template.requestType}/${this.template.requestId}/template/${this.template.uid}`;
      this.wopiUrl = wopiClientUrl + 'WOPISrc=' + wopiSrc;
      this.accessToken = localStorage.getItem('_token');
      // this.accessToken = data.token;
      this.cdref.detectChanges();
      setTimeout(() => {
        this.submitForm();
      }, 100);
    }, error => {
      console.error(error);
    });

  }
  submitForm(): void {
    this.form.nativeElement.submit();
  }
  private loadTemplateData(): void {

  }

  private saveToTextFile(textData: any): void {
    const a = document.createElement('a');
    const objectUrl = 'data:attachment/text,' + encodeURI(textData);
    // a.style = 'display: none';
    a.href = objectUrl;
    a.download = this.template.name + '-base64.txt' || 'sample-base64.txt';
    a.click();
    // URL.revokeObjectURL(objectUrl);
    a.remove();
  }
  private saveBlobPDF(blobData: any): void {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blobData);
    // a.style = 'display: none';
    a.href = objectUrl;
    a.download = this.template.name + '.pdf' || 'sample.pdf';
    a.click();
    URL.revokeObjectURL(objectUrl);
  }
  private saveBlobODT(blobData: any): void {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blobData);
    // a.style = 'display: none';
    a.href = objectUrl;
    a.download = this.template.name + '.odt' || 'sample.odt';
    a.click();
    URL.revokeObjectURL(objectUrl);
  }

  toggleSideMenu(): void {
    this.hideSideMenu = !this.hideSideMenu;
    this.cdref.detectChanges();
  }

  performAction(actionName: 'PREVIEW_AS_PDF' | 'SAVE_AS_PDF' | 'SAVE_AS_DOCX' |
    'SAVE_AS_BASE64' | 'PREVIEW_AS_BASE64' | 'PREVIEW_AS_DOCX'): void {

    // if (actionName === 'PREVIEW_AS_PDF') {
    //   this.loading = true;
    //   this.documentTemplatesService.mergeAndRenderTemplate({
    //     documentData: this.template.uid,
    //     backendProcessType: this.backendProcessType,
    //     fieldsDataMap: this.fieldsDataObject,
    //     groupsDataMap: this.groupsDataObject
    //   },
    //     this.template.uid).subscribe(blobData => {
    //       this.saveBlobPDF(blobData);
    //       this.loading = false;
    //     }, error => {
    //       console.error(error);
    //       this.loading = false;
    //     });
    // } else if (actionName === 'PREVIEW_AS_DOCX') {
    //   this.loading = true;
    //   this.documentTemplatesService.mergeAndGetTemplate({
    //     documentData: this.template.uid,
    //     backendProcessType: this.backendProcessType,
    //     fieldsDataMap: this.fieldsDataObject,
    //     groupsDataMap: this.groupsDataObject
    //   },
    //     this.template.uid).subscribe(blobData => {
    //       this.saveBlobODT(blobData);
    //       this.loading = false;
    //     }, error => {
    //       console.error(error);
    //       this.loading = false;
    //     });
    // } else if (actionName === 'SAVE_AS_DOCX') {
    //   this.loading = true;
    //   this.documentTemplatesService.getTemplate(
    //     this.template.uid).subscribe(blobData => {
    //       this.saveBlobODT(blobData);
    //       this.loading = false;
    //     }, error => {
    //       console.error(error);
    //       this.loading = false;
    //     });
    // } else if (actionName === 'SAVE_AS_PDF') {
    //   this.loading = true;
    //   this.documentTemplatesService.renderTemplateToPdf(
    //     this.template.uid).subscribe(blobData => {
    //       this.saveBlobPDF(blobData);
    //       this.loading = false;
    //     }, error => {
    //       console.error(error);
    //       this.loading = false;
    //     });
    // } else if (actionName === 'SAVE_AS_BASE64') {
    //   this.loading = true;
    //   this.documentTemplatesService.getBase64(
    //     this.template.uid).subscribe(textData => {
    //       this.saveToTextFile(textData);
    //       this.loading = false;
    //     }, error => {
    //       console.error(error);
    //       this.loading = false;
    //     });
    // } else if (actionName === 'PREVIEW_AS_BASE64') {
    //   this.loading = true;
    //   this.documentTemplatesService.mergeAndGetBase64({
    //     documentData: this.template.uid,
    //     backendProcessType: this.backendProcessType,
    //     fieldsDataMap: this.fieldsDataObject,
    //     groupsDataMap: this.groupsDataObject
    //   },
    //     this.template.uid).subscribe(textData => {
    //       this.saveToTextFile(textData);
    //       this.loading = false;
    //     }, error => {
    //       console.error(error);
    //       this.loading = false;
    //     });
    // }
  }
  saveAsPdf() {
    this.loading = true;
    this.documentTemplatesService.mergeAndRenderToPDFBase64({
      documentData: this.template.uid,
      backendProcessType: this.backendProcessType,
      fieldsDataMap: this.fieldsDataObject,
      groupsDataMap: this.groupsDataObject
    }, this.template.requestType, this.template.requestId).subscribe(textData => {
      this.saveMerged.emit(textData);
      this.emitClose();
    }, error => {
      console.error(error);
      this.loading = false;
      this.emitClose();
    });
  }
  close(): void {
    // this.loading = true;
    // this.documentTemplatesService.mergeAndGetBase64({
    //   documentData: this.template.uid,
    //   backendProcessType: this.backendProcessType,
    //   fieldsDataMap: this.fieldsDataObject,
    //   groupsDataMap: this.groupsDataObject
    // },
    //   this.template.uid).subscribe(textData => {
    //     this.saveMerged.emit(textData);
    //     this.documentTemplatesService.getBase64(
    //       this.template.uid).subscribe(textData2 => {
    //         this.saveTemplate.emit(textData2);
    //         this.loading = false;
    //         this.emitClose();
    //       }, error => {
    //         console.error(error);
    //         this.loading = false;
    //         this.emitClose();
    //       });
    //   }, error => {
    //     console.error(error);
    //     this.loading = false;
    //     this.emitClose();
    //   });
    this.emitClose();
  }
  private emitClose(): void {
    this.ngOnDestroy();
    this.processClose.emit(true);
  }
  ngOnDestroy(): void {

  }
}
